const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "类型",
        prop: "siteType",
        search: true,
        clearable: true,
        type: "select",
        dicData: [
          {
            label: '草地',
            value: '0'
          },
          {
            label: '湿地',
            value: '1'
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 0) {
            return "草地";
          } else if (Number(value) === 1) {
            return "湿地";
          }
          return "";
        }
      },
      {
        label: "场地名称",
        prop: "siteName",
      },
      {
        label: "场地面积(hm²)",
        prop: "siteArea",
      },
      {
        label: "碳汇系数(kg/hm²)",
        prop: "sinkCoefficient",
      },
      {
        label: "CO₂减排量(t)",
        prop: "co2Reduction",
      },
      {
        label: "备注",
        prop: "siteRemark",
      }
    ]
  };
};

export default tableOption;
